import React from 'react'
import projectsAPi from '../api/projects.json';
import { shuffledData } from '../utils/constant';
const Card=({proj_img,proj_name,proj_desc,proj_link,utlity})=>{
    const GetHandler=()=>{
        window.open(proj_link,"_blank")
    }
    return(
        <div   data-aos={Math.floor(Math.random()*10)%2==0?"fade-down":"fade-left"} className="col-lg-3" onClick={GetHandler}>
        <div className="project-wrapper">
            <div className="project-card">
                <div className="project-image-wrapper">
                    <img src={proj_img} alt={proj_name} className="project-image" />
                </div>
                <div className="project-detail">
                    <div className="project-title-wrapper">
                        <p className="project-title">
                            {proj_name}
                        </p>
                    </div>
                    <div className="project-description">
                                <p className="project-description">
                                {proj_desc}
                                </p>
                    </div>
                </div>
                <div className="project-techs">
                    {utlity.map((cur,i,arr)=>{

                    return <img  key={i} title={cur.name} src={cur.img} alt={cur.name} className="project-tech img-thumbnail" />
                    })}

                 {/* <img src="./media/html.svg" alt="HTML" className="project-tech img-thumbnail" />
                 <img src="./media/css.svg" alt="CSS" className="project-tech img-thumbnail" /> */}
                </div>

            </div>
        </div>
    </div>
    );
}

const Projects = () => {
    // console.log(projectsAPi);
  return (
    <>
            <div className="projects-section container">
                <div className="row">
                    <div className="project-text-column col-lg-12 ">
                        <div className="text-align-center">
                            <h2 className="section-heading">Projects 🖥️</h2>
                        </div>
                    </div>
                </div>
                <div className="projects-container row ">
               
               {shuffledData(projectsAPi).map((cur,i,arr)=>{
                return <Card key={i} proj_desc={cur.proj_desc} proj_img={cur.proj_img} proj_name={cur.proj_name} proj_link={cur.proj_link} utlity={cur.utility} />
               })}

                </div>
                </div>
    </>
  )
}

export default Projects